import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import Config from '../../../../Config';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import MainTitleComponent from '../Headline/MainTitleComponent';
import {images} from '../images/images';
import {createReportUpdateCellularPlan} from '../../../../utilities/reports/createReport';

const FamilyErrorComponent = ({props}) => {
  if (props.data.errorReason == 'server_error') return null;
  let titleBold = '...רק רגע';
  let description;
  let totalCount = parseInt(props.data.familyBalance) + parseInt(props.data.familyUsed);
  if (props.data.familyBalance == 0) {
    description = `מימשת ${props.data.familyUsed}/${props.data.familyUsed} הטבות לחבילות מיוחדות לבני משפחת ${props.organizationData?.name} `;
  } else if (props.data.familyBalance > 0) {
    description = `כמות המנויים שניתן להוסיף לחבילה זו מוגבלת ל-${totalCount}, אפשר להוסיף עד ${props.data.familyBalance} מנויים נוספים`;
  } else if (props.data.familyBalance < 0) {
    description = `כמות המנויים שניתן להוסיף לחבילה זו מוגבלת ל-${totalCount}, אין באפשרותך להוסיף מנויים נוספים`;
  }

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }

    props.saveToHistory('msg');
  }, []);
  async function buttonFunction() {
    let content = await props.context.loadContentByPath(Config.lobbyUrl);
    props.context.navigateTo(content);
  }

  useEffect(() => {
    const customerName = props.userData?.loginData?.userDetails?.firstName + ' ' + props.userData?.loginData?.userDetails?.lastName;
    const subscriber = props.userData?.loginData?.userDetails?.contactNumber;
    const idNumber = props.userData?.loginData?.userDetails?.IDNumber;

    createReportUpdateCellularPlan(
      'Error',
      props.data?.selectedAccount?.newPackage?.offerID,
      props.data?.allCellularPackagesForAccountData[0]?.pricePlan,
      props.data?.selectedAccountExtendedData?.banlvl_pp_limited,
      customerName,
      subscriber,
      idNumber
    );
  }, []);

  return (
    <div className='failure-container family'>
      <MainTitleComponent title={'שינוי חבילת סלולר'} />

      <div className='image'>
        <Image src={images.error} alt='image' />
      </div>

      <div className='d-flex justify-content-center'>
        <div className='bold main-text d-block fs-36'>
          <span dangerouslySetInnerHTML={{__html: titleBold}} />
        </div>
      </div>
      {description.trim() != '' && (
        <div className='d-flex justify-content-center text-center'>
          <div className='description'>
            <span dangerouslySetInnerHTML={{__html: description}} />
          </div>
        </div>
      )}
      <div className='d-flex justify-content-center'>
        <div className='btn-wrapper'>
          <BtnSubmit formid='failure-screen' onclick={() => buttonFunction()} text='חזרה לאיזור האישי'></BtnSubmit>
        </div>
      </div>
    </div>
  );
};

export default FamilyErrorComponent;
